import script from "./registerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./registerModal.vue?vue&type=script&setup=true&lang=js"

import "./registerModal.vue?vue&type=style&index=0&id=214b64e2&scoped=true&lang=scss"
import "./registerModal.vue?vue&type=style&index=1&id=214b64e2&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-214b64e2"]])

export default __exports__